module.exports = __webpack_public_path__ + "security-testing.3WrwRZ6d.svg";